import {
  LayoutDashboard, GraduationCap, Wrench, GitBranch, Video, Boxes,
  Phone, Mail, ExternalLink, ShieldAlert, Shield, Settings,
} from "lucide-react";

export const NAV_CARDS = [
  { key: "training", title: "Start Training", to: "/training", icon: GraduationCap, color: "success", desc: "Complete your warranty training modules", span: true,
    img: "https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { key: "troubleshoot", title: "Troubleshoot a Product", to: "/troubleshooting", icon: Wrench, color: "action", desc: "Search articles & guided diagnosis", span: true,
    img: "https://images.unsplash.com/photo-1647376036543-f9f543601a1d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { key: "workflow", title: "Warranty Claim Workflow", to: "/workflow", icon: GitBranch, color: "mlily", desc: "The end-to-end claim process" },
  { key: "videos", title: "Troubleshooting Videos", to: "/videos", icon: Video, color: "media", desc: "Approved video library" },
  { key: "parts", title: "Spare Parts & Replacement", to: "/spare-parts", icon: Boxes, color: "partscyan", desc: "Parts & approval process" },
  { key: "contacts", title: "Inspection & Service Contacts", to: "/contacts", icon: Phone, color: "mlily", desc: "Service provider directory" },
  { key: "templates", title: "Customer Reply Templates", to: "/templates", icon: Mail, color: "action", desc: "Approved email templates" },
  { key: "safety", title: "Safety & Escalation Rules", to: "/safety", icon: ShieldAlert, color: "escalate", desc: "STOP & escalate rules" },
  { key: "technician", title: "Technician Procedures", to: "/technician", icon: Wrench, color: "escalate", desc: "Trained staff / technician only" },
];

export const SIDEBAR_LINKS = [
  { title: "Dashboard", to: "/", icon: LayoutDashboard },
  { title: "Training", to: "/training", icon: GraduationCap },
  { title: "Troubleshooting", to: "/troubleshooting", icon: Wrench },
  { title: "Workflow", to: "/workflow", icon: GitBranch },
  { title: "Videos", to: "/videos", icon: Video },
  { title: "Spare Parts", to: "/spare-parts", icon: Boxes },
  { title: "Contacts", to: "/contacts", icon: Phone },
  { title: "Templates", to: "/templates", icon: Mail },
  { title: "Safety", to: "/safety", icon: ShieldAlert },
  { title: "Technician Procedures", to: "/technician", icon: Wrench },
];

export const COLOR_MAP = {
  mlily: { text: "text-mlily-blue", bg: "bg-mlily-blue", soft: "bg-blue-50", border: "hover:border-mlily-blue", ring: "ring-mlily-blue" },
  success: { text: "text-emerald-600", bg: "bg-emerald-500", soft: "bg-emerald-50", border: "hover:border-emerald-500", ring: "ring-emerald-500" },
  action: { text: "text-amber-600", bg: "bg-amber-500", soft: "bg-amber-50", border: "hover:border-amber-500", ring: "ring-amber-500" },
  media: { text: "text-violet-600", bg: "bg-violet-500", soft: "bg-violet-50", border: "hover:border-violet-500", ring: "ring-violet-500" },
  partscyan: { text: "text-cyan-600", bg: "bg-cyan-500", soft: "bg-cyan-50", border: "hover:border-cyan-500", ring: "ring-cyan-500" },
  escalate: { text: "text-red-600", bg: "bg-red-500", soft: "bg-red-50", border: "hover:border-red-500", ring: "ring-red-500" },
};

export { Settings, Shield, ExternalLink };
